import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import PPSIView from './PumpSpareInternational/View';
import PAMDView from './AraiManufacturing/View';

function PView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [purchasetype, setpurchasetype] = useState('');
  const [purchasecategory, setpurchasecategory] = useState('');
  const [purchaseData, setPurchaseData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}purchase/findById/${id}`, {
          headers: authHeader(),
        });
        setPurchaseData(response.data);
        setpurchasetype(response.data.purchasetype);
        setpurchasecategory(response.data.purchasecategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (purchasetype === 'Pump Spare' && purchasecategory === 'International') {
      return <PPSIView />;
    } else if (purchasetype === 'Manufacturing') {
      return <PAMDView />;
    }
    return null;
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}purchase/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/pindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW PURCHASE </h6>
          <div>
            <strong>Type:</strong> {purchasetype} | <strong>Category:</strong> {purchasecategory}
          </div>
          <div className="view-buttons">
            {(purchasecategory === "Domestic" || purchasecategory === "International") && purchaseData?.status === "Open" && (
              <Link to={`/ptoprconvert/${id}`}>
                <button className="button-70">Convert To Purchase Return</button>
              </Link>
            )}
            {purchaseData?.status === "Open" && purchaseData?.status !== "Cancelled" && (
              <Link to={`/pEdit/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}
            <Link to={`/pindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {renderPageDisplay()}
      </Card>
    </div>
  );
}

export default PView;
